import {RootLayout, RsnMessage, useBoolean} from '@raison/ui-kit';
import React, {useMemo} from 'react';
import {UploadDocs, UploadSuccessScreen} from '~/entities/verification-files';
import {cardStatusQuery} from '../../api/cardQueryHooks';
import {useCardIdParam} from '../CardIdParam';
import card from './card.webp';

export function CardVerificationPage() {
    const cardId = useCardIdParam();
    const cardStatus$ = useMemo(() => cardStatusQuery(cardId), [cardId]);
    const [isSuccess, setIsSuccess] = useBoolean(false);

    if (isSuccess) {
        return (
            <UploadSuccessScreen
                title={'Files sent'}
                message={
                    "We will review your files as soon as possible. Don't worry, it usually takes no more than 3 business days."
                }
            />
        );
    }

    return (
        <RootLayout title='Card verification'>
            <div className='flex flex-1 flex-col gap-6 px-4 pb-4 pt-6'>
                <div className='fv-text-l-regular text-neutral-90'>
                    Please upload a photo of your bank card with{' '}
                    <span className='fv-text-l-bold'>6 first and 4 last digits,</span> and your name on it. If they are
                    on different sides, upload photos of both sides.
                </div>
                <RsnMessage.Notification>
                    For your safety, close the extra digits of the card number and the CVC code so that they are not
                    visible in the photo.
                </RsnMessage.Notification>
                <img src={card} height={216} width='100%' />
                <UploadDocs
                    docsStatus$={cardStatus$}
                    uploadUrl={`/v1/document/card/${cardId}`}
                    maxFilesAmount={2}
                    onSuccess={setIsSuccess.on}
                />
            </div>
        </RootLayout>
    );
}
